import { GET_CONTENT_CREATOR, UPDATE_CONTENT_CREATOR_STATUS, DELETE_CONTENT_CREATOR } from "./contentCreator.type";

const initialState = {
  contentCreators: [],
  total: 0,
};

const contentCreatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTENT_CREATOR:
      return {
        ...state,
        contentCreators: action.payload,
        total: action.payload.length,
      };
    case UPDATE_CONTENT_CREATOR_STATUS:
      return {
        ...state,
        contentCreators: state.contentCreators.map((creator) =>
          creator._id === action.payload.id
            ? { ...creator, isActive: action.payload.isActive }
            : creator
        ),
      };
    case DELETE_CONTENT_CREATOR:
      return {
        ...state,
        contentCreators: state.contentCreators.filter((creator) => creator._id !== action.payload),
        total: state.total - 1,
      };
    default:
      return state;
  }
};

export default contentCreatorReducer;